// i18n area 'backups' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.de-DE.meta.json.
import type { enUS } from './backups'

export const deDE: typeof enUS = {
  ckpt: {
    contents: 'Akzeptiert',
    contentsHint:
      'Was hier landen darf. „Checkpoints“ ist die Cluster-Konfiguration, „Datensicherungen“ sind die der VMs: Beide Lesarten setzen sich zusammen, ein Ziel kann beide annehmen.',
    content: { checkpoints: 'Checkpoints', backups: 'Datensicherungen' },
    destinationsTitle: 'Backup-Ziele',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Wiederherstellung',
    addDestination: 'Ziel hinzufügen',
    addDestinationTitle: 'Backup-Ziel hinzufügen',
    editDestinationTitle: 'Ziel bearbeiten',
    storage: 'Storage',
    storageHint:
      'Ein dir-like Storage (dir/NFS/CIFS/CephFS) — die Artefakte sind normale Dateien unter dem Namespace der Plattform.',
    schedule: 'Zeitplan',
    scheduleNone: 'Nur manuell',
    scheduleHourly: 'Stündlich',
    scheduleDaily: 'Täglich',
    scheduleWeekly: 'Wöchentlich',
    scheduleHour: 'Stunde',
    scheduleWeekday: 'Tag',
    scheduleHint:
      'Geplante Checkpoints haben keinen Operator, der die Masterpass eintippt: Die Geheimnisse des Keystores werden als Placeholder verpackt.',
    retention: 'Retention',
    retentionHint:
      'Wie viele geplante Checkpoints behalten werden — der Sweeper entfernt die ältesten über der Anzahl. Manuelle Checkpoints und Checkpoints vor Wiederherstellung werden nie entfernt.',
    paused: 'Pausiert',
    pausedHint:
      'Der Blackout des Operators: solange pausiert ist, wird auf diesem Ziel nichts geplant und nichts entfernt — Daten-Policies wie Checkpoints gleichermaßen. Laufende Jobs werden nie angetastet.',
    orphanRuns: '{n} verwaiste Läufe',
    orphanRunsHint:
      'Geplante Läufe von Policies, die es auf diesem Ziel nicht mehr gibt: keine Retention regiert sie — nie gezählt, nie aufgeräumt — und nur eine Hand löscht sie. Die Linse „backups“ von tvirt diagnose nennt die entfernten Policies.',
    rescan: 'Artefakte neu adoptieren',
    rescanTitle: 'Artefakt-Neuadoption von {name}',
    rescanHint:
      'Baut den Backup-Katalog (VM/CT/App) aus den Manifesten der auf dem Ziel vorhandenen Artefakte neu auf. Bestehende Zeilen werden nie angetastet; Backups unbekannter Richtlinien bleiben Waisen (nie automatisch beschnitten). Der Schritt nach einer Bootstrap-Wiederherstellung.',
    masterpassDrWarning:
      'Katastrophenszenario: LUKS-Datenträger kehren NUR aus einem Checkpoint MIT Masterpasswort zurück. Geplante Checkpoints packen Platzhalter — nimm regelmäßig einen manuellen Checkpoint mit Masterpasswort.',
    policy: {
      title: 'Policies für Datensicherungen',
      hint: 'Benannte Policies: welche Objekte (kind, Tags, Scopes), wie oft, wann ein Lauf starten darf und wie viele Kopien behalten werden. Die Geste der Einschreibung bleibt beim Eigentümer des Objekts: Die Tags werden auf seinem eigenen Scope vergeben.',
      add: 'Policy hinzufügen',
      column: 'Daten-Policies',
      name: 'Name',
      nameHint:
        'Label der Policy, eindeutig innerhalb des Ziels. Die Läufe folgen der stabilen Id der Policy: Umbenennen ist kostenlos; Löschen macht ihre Läufe zu Waisen (weder gezählt noch aufgeräumt).',
      kindLocked: 'Die Objektfamilie einer bestehenden Policy lässt sich nicht ändern: lege eine neue Policy an.',
      kindLabel: 'Objekte',
      kind: { vm: 'Virtuelle Maschinen', ct: 'Container', app: 'Apps' },
      tags: 'Tag-Selektor',
      tagsHint:
        'Paare tag=Wert, kommagetrennt, per UND verknüpft. Leere Tags und Scopes wählen nichts aus — nie „alles“.',
      scopes: 'Scopes',
      scopesHint: 'Scope-Pfade (Teilbäume), kommagetrennt, untereinander per ODER verknüpft.',
      windowStart: 'Fenster von',
      windowEnd: 'Fenster bis',
      windowHint:
        'Ausführungsfenster (HH:MM, lokale Uhrzeit; liegt der Beginn hinter dem Ende, geht es über Mitternacht). Es begrenzt nur den START: Ein Lauf, der es überzieht, wird nie abgebrochen.',
      mode: 'Modus',
      modeHint:
        'Inkrementell reitet auf der Serienfamilie; eine gerissene Serie degradiert zu einem Full, vermerkt im Journal.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementell',
      requireQuiesce: 'Quiesce verlangen (Guest Agent)',
      paused: 'Policy pausiert',
      retentionNone: 'Alles behalten',
      retentionCount: 'Anzahl',
      retentionGfs: 'GFS-Ringe',
      gfs: { keepLast: 'Letzte', daily: 'Täglich', weekly: 'Wöchentlich', monthly: 'Monatlich', yearly: 'Jährlich' },
      gfsHint:
        'Für jeden Ring wird das neueste Backup jeder der letzten N Perioden behalten. Ein behaltenes Backup hält seine ganze Kette am Leben — nie eine Basis mit Waisen.',
      lastRun: 'Letzter Lauf',
      neverRan: 'nie gelaufen'
    },
    lastCheckpoint: 'Letzter Checkpoint',
    neverRun: 'Nie erstellt',
    createNow: 'Checkpoint erstellen',
    createNowTitle: 'Checkpoint erstellen — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Schützt die geheimen Werte des Keystores (argon2id → AES-256-GCM, pro Wert). Sie wird nie gespeichert: Bewahren Sie sie auf — ohne sie liefert eine Wiederherstellung Placeholder statt der echten Geheimnisse.',
    masterpassEmptyHint: 'Leer lassen, um explizite Placeholder statt der Geheimnisse zu verpacken.',
    createStarted: 'Checkpoint läuft…',
    destinationInUseError: "'{name}' enthält noch Checkpoints — löschen Sie diese zuerst.",
    origin: 'Herkunft',
    originManual: 'manuell',
    originSchedule: 'geplant',
    originPreRestore: 'vor Wiederherstellung',
    originPreChange: 'vor Änderung',
    preChangeRetention: 'Pre-Change-Checkpoints',
    preChangeRetentionHint:
      'Leer = deaktiviert. Der erste Konfigurations-Write nach einer Ruhephase friert hier den vorherigen Zustand ein (Ursprung „vor Änderung“); die neuesten bleiben bis zur Anzahl erhalten — eigene, löschbare Retention.',
    diffTitle: 'Änderungsvorschau',
    diffFailed: 'Vorschau fehlgeschlagen',
    diffRetry: 'Erneut versuchen',
    diffCounts: '{changed} zu ändern · {missing} zu erstellen · {extra} überzählig · {equal} identisch',
    diffChanged: 'ändert sich',
    diffMissing: 'würde erstellt',
    diffExtra: 'würde gelöscht',
    diffJsonb: 'jsonb-Referenzen vor dem Anwenden nicht prüfbar',
    diffSecret: 'versiegelte Felder, nicht vergleichbar',
    diffMore: '{n} weitere…',
    diffNeeded: 'Der Start wird scharf, sobald die Vorschau die Auswahl widerspiegelt.',
    phase: 'Zustand',
    phaseRunning: 'läuft',
    phaseComplete: 'abgeschlossen',
    phaseError: 'Fehler',
    secrets: 'Geheimnisse',
    secretsMasterpass: 'Masterpass',
    secretsPlaceholders: 'Placeholder',
    size: 'Größe',
    created: 'Erstellt',
    destination: 'Ziel',
    download: '.tvbk herunterladen',
    deleteCheckpoint: 'Checkpoint löschen',
    noCheckpoints: 'Keine Checkpoints — erstellen Sie einen von einem Ziel aus.',
    families: 'Familien',
    generation: 'Generation',
    completedAt: 'Abgeschlossen am',
    errorDetail: 'Fehlerdetail',
    manifest: 'Manifest',
    restoreHint:
      'Laden Sie ein .tvbk-Artefakt hoch: Der Explorer zeigt, was es enthält, dann wählen Sie, was wiederhergestellt wird und wie.',
    uploadFile: 'Eine .tvbk-Datei hochladen',
    uploading: 'Wird hochgeladen…',
    uploadFailed: 'Das Artefakt konnte nicht geöffnet werden',
    explorerTitle: 'Inhalt des Checkpoints',
    checkpointFrom: 'Checkpoint des Clusters {cluster}, erstellt am {when} ({origin}, Generation {generation})',
    otherCluster:
      'Dieser Checkpoint stammt von einem ANDEREN Cluster ({cluster}) — die Cross-Cluster-Wiederherstellung kommt in einem künftigen Round.',
    encrypted: 'verschlüsselt',
    objectsCount: '{n} Objekte',
    mode: 'Modus',
    modeMerge: 'Merge — gleicht ab: Upsert der ausgewählten Zeilen, nichts wird gelöscht',
    modeOverwrite:
      'Overwrite — der Checkpoint gewinnt: Eine vollständig ausgewählte Familie wird als Ganzes ersetzt (aktuelle Zeilen, die im Checkpoint fehlen, sterben)',
    restoreMasterpassHint:
      'Die Masterpass, mit der der Checkpoint erstellt wurde. Ohne sie werden die verschlüsselten Geheimnisse als explizite Placeholder wiederhergestellt.',
    checkMasterpass: 'Prüfen',
    masterpassOk: 'Masterpass korrekt',
    masterpassWrong: 'Masterpass falsch',
    parachuteDestination: 'Fallschirm-Ziel',
    parachuteHint:
      'Bevor irgendeine Zeile angefasst wird, erstellt der Task hier einen automatischen Checkpoint vor der Wiederherstellung.',
    summaryTitle: 'Was passieren wird',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'ganze Familie',
    summaryObjects: '{n} ausgewählte Objekte',
    confirmHint:
      'Geben Sie den Namen des Clusters ({name}) ein, um zu bestätigen — eine Wiederherstellung schreibt die deklarierte Konfiguration neu.',
    confirmField: 'Name des Clusters',
    startRestore: 'Wiederherstellen',
    restoreRunning: 'Wiederherstellung läuft…',
    restoreDone: 'Wiederherstellung abgeschlossen — die Reconciler konvergieren auf die neue Deklaration.',
    restoreFailed: 'Die Wiederherstellung ist fehlgeschlagen',
    discard: 'Verwerfen',
    selectionEmpty: 'Wählen Sie mindestens eine Familie oder ein Objekt aus.'
  },

  backup: {
    intro: {
      title: 'Backup der VM- und Container-Daten',
      subtitle: 'Die Bausteine, die externe Backup-Software nutzt',
      whatItIs:
        'TVirt stellt vier Primitiven bereit: quiesced Snapshots, Change Tracking pro Festplatte, NBD-Export nur zum Lesen und Export der Konfiguration. Gesteuert werden sie von Veeam, Bacula, Acronis und Co.',
      whatItIsNot:
        'TVirt ist kein Backup-Produkt: Es plant nichts, wendet keine Retention an und bewahrt kein Archiv Ihrer Daten auf. Retention, Kataloge und Wiederherstellungsrichtlinien bleiben bei der Software, die Sie bereits verwenden.'
    },
    cbt: {
      title: 'Change Tracking',
      colVm: 'VM',
      colDisk: 'Festplatte',
      colState: 'Zustand',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Beobachtet',
      colChangeId: 'Change-ID',
      colMechanic: 'Mechanik',
      stateActive: 'Aktiv',
      stateInactive: 'Inaktiv',
      stateInconsistent: 'Inkonsistent — das nächste Backup muss vollständig sein',
      stateBroken: 'Kette unterbrochen — deaktivieren, dann als neue Kette aktivieren',
      stateSnapshots: 'Immer aktiv — Delta zwischen Snapshots',
      stateUnavailable: 'Auf dieser Festplatte nicht verfügbar',
      mechanic: {
        'qcow2-bitmap': 'qcow2-Bitmap',
        'rbd-snapdiff': 'Ceph-Snapshot-Diff',
        'lvm-thin-delta': 'Thin-Pool-Delta',
        none: 'Keine'
      },
      empty:
        'Keine VM-Festplatte. Change Tracking wird pro Festplatte gelesen: auf einer qcow2-Festplatte aktivieren oder auf rbd/SAN Snapshots anlegen.',
      chainBroken: 'Kette unterbrochen',
      chainBrokenText:
        'Durch {reason} unterbrochen: {bitmaps}. Bitmap deaktivieren (die Kette ist verloren, das nächste Backup ist vollständig), dann als neue Kette aktivieren.',
      lineages: 'Epochen',
      epochFrozen: 'eingefroren im Snapshot {snapshot}',
      epochLost: 'verloren ({cause})',
      epochRecording: 'aufzeichnend auf dem Kopf',
      milestones: 'Snapshot-Meilensteine',
      enable: 'Change Tracking aktivieren',
      disable: 'Deaktivieren',
      reset: 'Zurücksetzen',
      changedAreas: 'Geänderte Bereiche',
      denied: 'Ihnen fehlt die Berechtigung auf dieser VM',
      enableTitle: 'Change Tracking aktivieren',
      disableTitle: 'Change Tracking deaktivieren',
      resetTitle: 'Bitmap zurücksetzen',
      areasTitle: 'Geänderte Bereiche',
      bitmapName: 'Bitmap-Name',
      bitmapNameHint: 'Ein eigener Name: tvirt- und tvbk- gehören der Plattform',
      granularity: 'Granularität (Byte)',
      granularityHint: 'Eine Zweierpotenz; Standard 65536',
      bitmap: 'Bitmap',
      disableHint: 'Entfernt die Bitmap und ihre gesamte Epochen-Historie: das nächste Backup muss vollständig sein.',
      resetHint:
        'Leert die Bitmap — eine neue Basis: eine Change-ID vor dem Zurücksetzen ist nicht mehr zusammensetzbar.',
      areasFrom: 'Von Snapshot',
      areasTo: 'Bis Snapshot',
      areasRun: 'Berechnen',
      areasResult: '{count} geänderte Bereiche, {bytes}',
      areasEmpty: 'Kein geänderter Bereich zwischen den beiden Snapshots',
      areasZero: 'Nullen',
      areasMore: 'die ersten {shown} von {count} angezeigt',
      submit: 'Bestätigen',
      error: 'Die Change-Tracking-Aktion ist fehlgeschlagen'
    },
    exports: {
      title: 'Offene NBD-Exporte',
      colVm: 'VM',
      colDisk: 'Festplatte',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Phase',
      colNode: 'Knoten',
      colEndpoint: 'Endpoint',
      colExpires: 'Läuft ab',
      colCreated: 'Geöffnet',
      colError: 'Fehler',
      phase: {
        preparing: 'In Vorbereitung',
        ready: 'Bereit',
        closed: 'Geschlossen',
        error: 'Fehlgeschlagen'
      },
      expiresIn: 'in {minutes} Min',
      expired: 'abgelaufen',
      empty: 'Kein Export. Eine Lesesitzung stellt eine Festplatte zu einem Snapshot einem NBD-Client bereit; eine Schreibsitzung füllt eine unberührte Festplatte einer gestoppten VM. Beide enden mit dem Ablauf.',
      endpointHint: 'TLS mit der Cluster-CA; der Exportname ist das Ticket — es stirbt mit der Sitzung',
      closeDenied: 'Ihnen fehlt die Berechtigung, Exporte dieser VM zu schließen',
      open: 'NBD-Export öffnen',
      openTitle: 'Einen NBD-Export öffnen',
      openDisk: 'Festplatte',
      openBitmap: 'Bitmap (optional)',
      openBitmapHint:
        'Veröffentlicht die in diesem Snapshot eingefrorene Epoche dieser Bitmap als Meta-Context der geänderten Extents (nur qcow2-Festplatten)',
      openTtl: 'Lebensdauer (Minuten)',
      openSubmit: 'Öffnen',
      openError: 'Der Export konnte nicht geöffnet werden',
      colMode: 'Modus',
      mode: {
        read: 'Lesen',
        write: 'Schreiben'
      },
      caCertificate: 'Cluster-CA',
      caCopy: 'PEM kopieren',
      caDownload: 'ca-cert.pem herunterladen',
      caHint: 'Das PEM als ca-cert.pem in ein privates Verzeichnis schreiben und mit nbds://…?tls-certificates=<Verzeichnis> (nbdcopy, nbdinfo) oder --object tls-creds-x509,dir=<Verzeichnis>,endpoint=client (qemu-img) verbinden',
      caAbsent: 'Die Sitzung trägt keine CA (keine PKI)',
      openWrite: 'Schreib-Export öffnen',
      openWriteTitle: 'Einen Schreib-Export öffnen',
      openWriteIntro: 'Die Festplatte muss unberührt sein: leer geboren, nie beschrieben, ohne Snapshot; die VM gestoppt. Die Wiederherstellung FÜLLT die Festplatte, sie repariert sie nicht. Solange die Sitzung offen ist, kann die VM nicht starten, keinen Snapshot nehmen, nicht geklont werden, und die Festplatte nicht verschoben werden.',
      openWriteSubmit: 'Öffnen',
      openWriteError: 'Der Schreib-Export konnte nicht geöffnet werden',
      openWriteDenied: 'Ihnen fehlt vm.restore.data auf dieser VM',
      openWriteStopped: 'Stoppen Sie die VM, um einen Schreib-Export zu öffnen',
      fromDescription: 'VM aus Beschreibung erstellen',
      fromDescriptionTitle: 'Eine VM aus einer Beschreibung erstellen',
      fromDescriptionIntro: 'Die Beschreibung von export-vm-meta kommt als gestoppte VM mit leeren Festplatten der beschriebenen Geometrie zurück — bereit für die Schreib-Exporte, Festplatte für Festplatte. Die Bytes laufen nicht hier durch: restore-disk (CLI) oder der NBD-Client des Backup-Produkts trägt sie.',
      fromDescriptionDoc: 'Beschreibung (JSON)',
      fromDescriptionDocHint: 'Das Dokument von export-vm-meta einfügen oder die Datei wählen',
      fromDescriptionFile: 'Datei wählen…',
      fromDescriptionInvalid: 'Der Text ist kein JSON-Dokument',
      fromDescriptionName: 'Name der neuen VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Ihr Heimat-Scope',
      fromDescriptionStorage: 'Festplatten-Storage',
      fromDescriptionStorageHint: 'Jede Festplatte entsteht hier, im Standardformat des Storage',
      fromDescriptionMetadataStorage: 'Metadaten-Storage',
      fromDescriptionSameAsStorage: 'Derselbe wie die Festplatten',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Ohne Bridge oder Netz entsteht die VM ohne Netzwerkkarten',
      fromDescriptionNetwork: 'Logisches Netz (Fabric/Netz)',
      fromDescriptionSubmit: 'Erstellen',
      fromDescriptionError: 'Die VM konnte nicht erstellt werden',
      fromDescriptionDone: 'VM erstellt: {name}',
      fromDescriptionOpen: 'VM öffnen',
      fromDescriptionDenied: 'Ihnen fehlt vm.create',
      fromDescriptionStillRunning: 'Die Erstellung läuft noch: es wird weiter gewartet'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Datensicherungen der VMs',
      titleOnVm: 'Datensicherungen',
      empty:
        'Keine Sicherung. Eine Sicherung kopiert die Festplatten, den UEFI-Varstore und den vTPM-Zustand auf ein Ziel und überlebt die VM.',
      colVm: 'VM',
      colCreated: 'Erstellt am',
      colPhase: 'Ergebnis',
      colDestination: 'Ziel',
      colContains: 'Inhalt',
      colSize: 'Größe',
      colOrigin: 'Herkunft',
      colMode: 'Art',
      retentionChip: 'Retention',
      retentionHint:
        'Die Retention des Ziels kann diese Sicherung ungefragt löschen: Sie stammt aus einer Planung. Manuelle Sicherungen werden nie weggeräumt.',
      policyRemoved: 'Policy entfernt: {name}',
      policyRemovedHint:
        'Die Policy, die dieses Backup geplant hat, existiert nicht mehr: keine Retention regiert es (nie automatisch aufgeräumt) — lösche es von Hand, wenn es nicht mehr gebraucht wird.',
      phase: {
        running: 'Läuft',
        complete: 'Abgeschlossen',
        error: 'Fehlgeschlagen'
      },
      origin: {
        manual: 'Manuell',
        schedule: 'Geplant'
      },
      mode: {
        full: 'Vollständig',
        incremental: 'Inkrementell'
      },
      contains: {
        disks: 'Festplatten',
        varstore: 'UEFI-Varstore',
        vtpm: 'vTPM-Zustand',
        snapshots: 'Snapshots'
      },
      vmState: {
        stopped: 'VM gestoppt',
        running: 'VM läuft (heiß)'
      },
      artifactClass: { metadata: 'Metadaten', data: 'Daten', secret: 'Geheimnis' },
      detail: {
        tabOverview: 'Überblick',
        tabArtefact: 'Artefakt',
        id: 'Kennung',
        scope: 'Geltungsbereich',
        vmState: 'VM-Zustand bei der Kopie',
        pointInTime: 'Datenstand',
        completedAt: 'Beendet am',
        node: 'Kopierender Knoten',
        error: 'Fehler',
        path: 'Verzeichnis auf dem Speicher',
        checksum: 'sha256 des Manifests',
        secretsExposed: 'Sensibles Material im Klartext',
        secretsExposedYes: 'Ja — das Ziel verschlüsselt nicht',
        secretsExposedNo: 'Nein',
        baseBackup: 'Basissicherung',
        tabManifest: 'Manifest',
        manifestHint:
          'Der Klartextindex des Artefakts: eine Datei pro Zeile mit ihrem sha256. Das Verzeichnis lässt sich auch ohne TVirt prüfen — qemu-img, tar und jq genügen.',
        manifestEmpty: 'Das Manifest führt keine Dateien auf.',
        manifestError: 'Das Manifest ist nicht lesbar',
        colEntry: 'Datei',
        colClass: 'Klasse',
        colSha: 'sha256'
      },
      create: {
        action: 'Jetzt sichern',
        title: 'Jetzt sichern',
        submit: 'Sicherung starten',
        destination: 'Ziel',
        destinationHint: 'Nur Ziele, die Sicherungen annehmen.',
        noDestinations: 'Kein Ziel nimmt Sicherungen an: Legen Sie eines unter System → Checkpoints an.',
        contentsHint:
          'Alle Festplatten reisen mit, dazu der UEFI-Varstore und der vTPM-Zustand. Die letzten beiden sind der Punkt: Ein versiegelter Gast muss wieder starten.',
        error: 'Die Sicherung ist nicht gestartet',
        stillRunning: 'Sicherung läuft noch — die Kopie geht weiter, auch wenn Sie schließen.',
        vmRunning:
          'Die VM ist {phase}: Ein Backup braucht eine stabile VM — gestoppt für die kalte Kopie, laufend für die heiße.'
      },
      restore: {
        action: 'Wiederherstellen',
        title: 'Wiederherstellen',
        intro:
          'Eine Wiederherstellung ist unumkehrbar. Wählen Sie, wohin die Daten zurückkehren: in eine neue Maschine oder über die ursprüngliche.',
        modeNewVm: 'In eine NEUE VM wiederherstellen',
        modeNewVmHint:
          'Rührt nichts Bestehendes an — damit prüft man eine Sicherung. Neue Kennung und frisch vergebene MACs.',
        modeOver: 'Die ursprüngliche VM überschreiben',
        modeOverHint: 'Zerstört die aktuellen Daten der Ziel-VM, ohne Rückweg. Die VM muss gestoppt sein.',
        newName: 'Name der neuen VM',
        newNameHint: 'Er muss im Zielbereich frei sein.',
        storage: 'Speicher für die Festplatten',
        storageHint:
          'Pflichtfeld: Das Manifest hält Größe und Format einer Festplatte fest, nie den Speicher, auf dem sie lag.',
        metadataStorage: 'Speicher für Varstore und vTPM',
        metadataStorageHint: 'Wohin die UEFI-Identität und der vTPM-Zustand landen.',
        sameAsStorage: 'Derselbe wie die Festplatten',
        bridge: 'Host-Bridge',
        bridgeHint:
          'Jede erfasste Netzwerkkarte kehrt auf dieser Bridge mit einer neuen MAC zurück. Leer gelassen, entsteht die VM ohne Karten — der sicherere Standard.',
        overwriteTitle: 'Sie sind dabei, diese VM zu überschreiben',
        overwriteName: 'Name',
        overwriteId: 'Kennung',
        overwriteDisks: 'Festplatten, die überschrieben werden',
        overwriteNoDisks: 'Keine Festplatte.',
        overwriteKeeps:
          'Unangetastet bleiben Kennung, Name, Geltungsbereich, Netzwerkkarten und MACs: Eine Sicherung sind die DATEN, die Konfiguration ist der Checkpoint.',
        confirmField: 'Name der VM',
        confirmHint: 'Geben Sie {name} ein, um zu bestätigen.',
        targetLoading: 'Ziel-VM wird gelesen…',
        targetRunning:
          'Die Ziel-VM ist {phase}: Eine Wiederherstellung überschreibt die Bytes unter dem Gast und verlangt sie daher gestoppt.',
        targetGone: 'Die ursprüngliche VM ist nicht mehr lesbar: Die Wiederherstellung in eine neue VM bleibt möglich.',
        onlyComplete: 'Die Sicherung ist {phase}: Nur eine abgeschlossene Sicherung kann wiederherstellen.',
        submitNewVm: 'In die neue VM wiederherstellen',
        submitOver: 'Überschreiben',
        error: 'Die Wiederherstellung ist nicht gestartet',
        stillRunning: 'Wiederherstellung läuft noch — ganze Festplatten zu kopieren dauert.'
      }
    },
    guest: {
      title: {
        ct: 'Container-Datenbackups',
        app: 'App-Datenbackups'
      },
      tabTitle: 'Backups',
      empty: 'Keine Backups. Ein Backup kopiert die persistenten Daten auf ein Ziel und überlebt sein Objekt.',
      colSubject: {
        ct: 'Container',
        app: 'App'
      },
      colCreated: 'Erstellt',
      colPhase: 'Ergebnis',
      colDestination: 'Ziel',
      colContains: 'Inhalt',
      colSize: 'Größe',
      colOrigin: 'Ursprung',
      policyRemoved: 'Policy entfernt: {name}',
      policyRemovedHint:
        'Die Policy, die dieses Backup geplant hat, existiert nicht mehr: keine Retention regiert es (nie automatisch aufgeräumt) — lösche es von Hand, wenn es nicht mehr gebraucht wird.',
      phase: {
        running: 'Läuft',
        complete: 'Abgeschlossen',
        error: 'Fehlgeschlagen'
      },
      origin: {
        manual: 'Manuell',
        schedule: 'Geplant'
      },
      state: {
        stopped: 'Objekt gestoppt',
        running: 'Objekt läuft (eingefroren)'
      },
      contains: {
        rootfs: 'Rootfs-Baum',
        config: 'Konfiguration',
        volumes: 'Persistente Volumes',
        root: 'Persistente Root'
      },
      artifactClass: {
        metadata: 'Metadaten',
        data: 'Daten',
        secret: 'Geheim'
      },
      create: {
        action: 'Jetzt sichern',
        title: 'Neues Backup',
        submit: 'Backup starten',
        error: 'Das Backup ist nicht gestartet',
        destination: 'Ziel',
        destinationHint: 'Nur Ziele, die Datenbackups akzeptieren.',
        noDestinations: 'Kein Ziel akzeptiert Datenbackups: füge einem Ziel „Datenbackups“ hinzu.',
        hint: {
          ct: 'Der gesamte Rootfs-Baum reist mit, originalgetreu (numerische Eigentümer, xattrs, ACLs), plus die deklarierte Konfiguration im Manifest. Ein laufender Container wird für die Dauer des Packens EINGEFROREN: crash-konsistente Kopie, deklariert.',
          app: 'NUR die persistenten Volumes (und die persistente Root) reisen mit, plus die Konfiguration im Manifest. Ephemere Teile sind per Ratifizierung ausgeschlossen und das Manifest benennt sie; als geheim deklarierte env-Werte reisen nicht.'
        },
        stillRunning: 'Backup läuft noch — ganze Bäume zu packen dauert.'
      },
      detail: {
        tabOverview: 'Übersicht',
        tabManifest: 'Manifest',
        id: 'Kennung',
        scope: 'Bereich',
        state: 'Zustand bei der Kopie',
        pointInTime: 'Daten zum Zeitpunkt',
        completedAt: 'Abgeschlossen am',
        node: 'Kopierender Knoten',
        error: 'Fehler',
        path: 'Verzeichnis auf dem Storage',
        checksum: 'Manifest-sha256',
        manifestHint:
          'Der Index des Artefakts: ein Eintrag pro Datei mit sha256 — ohne Hashes ist „das Backup ist da“ ein Akt des Glaubens.',
        manifestError: 'Das Manifest lässt sich nicht lesen',
        manifestEmpty: 'Keine Artefakte im Manifest.',
        colEntry: 'Datei',
        colClass: 'Klasse',
        colSha: 'sha256',
        excluded: 'Per Ratifizierung ausgeschlossen (reist nicht)',
        secretKeys: 'Ausgelassene geheime env-Schlüssel (#307) — nach einem Restore neu eingeben'
      },
      restore: {
        action: 'Wiederherstellen',
        title: 'Wiederherstellung',
        submit: 'Wiederherstellen',
        error: 'Die Wiederherstellung ist nicht gestartet',
        stillRunning: 'Wiederherstellung läuft noch — ganze Bäume zu entpacken dauert.',
        onlyComplete: 'Das Backup ist {phase}: nur ein abgeschlossenes Backup kann wiederherstellen.',
        asNew: {
          ct: 'In einen NEUEN Container — zerstört nichts: die Geste, mit der man ein Backup prüft',
          app: 'In eine NEUE App — zerstört nichts: die Geste, mit der man ein Backup prüft'
        },
        over: {
          ct: 'ÜBER den Quellcontainer — der gesamte Rootfs-Baum wird ersetzt',
          app: 'ÜBER die Quell-App — der Inhalt jedes persistenten Volumes wird ersetzt'
        },
        name: 'Name des neuen Objekts',
        storage: 'Storage',
        storageHint: 'Wo die wiederhergestellten Daten landen — das Manifest verzeichnet nie den verlorenen Pool.',
        storageDeclared: 'Die im Manifest deklarierten Storages',
        bridge: 'Host-Bridge',
        bridgeHint:
          'Jede verzeichnete NIC kehrt auf dieser Bridge mit frischer MAC zurück. Leer = unverbunden geboren, der sicherere Default.',
        node: 'Knoten',
        nodeHint:
          'Das Mitglied, auf dem die App wiedergeboren wird: der Knoten ist Cluster-Identität und kommt nie aus dem Manifest.',
        secretKeysWarning:
          'Als geheim deklarierte env-Werte reisen nicht im Backup: die wiedergeborene Kopie braucht sie neu (das Task-Log nennt die Schlüssel).',
        overInventory: 'Du bist dabei, dieses Objekt zu überschreiben',
        confirmType: 'Tippe {name} zur Bestätigung',
        targetGone: 'Das Quellobjekt lässt sich nicht mehr lesen: die Wiederherstellung als neu bleibt verfügbar.',
        targetLoading: 'Zielobjekt wird gelesen…',
        targetRunning:
          'Das Zielobjekt läuft: die Wiederherstellung ersetzt die Bytes unter dem Gast und will es daher gestoppt.'
      }
    }
  }
}
